 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import XHTML00_COVER from '@/components/xhtml/00_Cover'
 import XHTMLLOVE_1 from '@/components/xhtml/love_1'
 import XHTML00_SERIES_PAGE from '@/components/xhtml/00_Series_Page'
 import XHTML01_FRONTISPIECE from '@/components/xhtml/01_Frontispiece'
 import XHTML02_TITLE_PAGE from '@/components/xhtml/02_Title_Page'
 import XHTML03_COPYRIGHT from '@/components/xhtml/03_Copyright'
 import XHTML04_DEDICATION from '@/components/xhtml/04_Dedication'
 import XHTML05_CONTENTS from '@/components/xhtml/05_Contents'
 import XHTML06_ACKNOWLEDGMENTS from '@/components/xhtml/06_ACKNOWLEDGMENTS'
 import XHTML07_ABBREVIATIONS from '@/components/xhtml/07_ABBREVIATIONS'
 import XHTML08_INTRODUCTION from '@/components/xhtml/08_INTRODUCTION'
 import XHTML09_CHAPTER_1__FARM_WORKER_ORGANIZIN from '@/components/xhtml/09_CHAPTER_1__Farm_Worker_Organizin'
 import XHTML10_CHAPTER_2__DOLORES_HUERTA_S_LIFE from '@/components/xhtml/10_CHAPTER_2__Dolores_Huerta_s_Life'
 import XHTML11_CHAPTER_3__LETTERS_TO_C_SAR_CH_V from '@/components/xhtml/11_CHAPTER_3__Letters_to_C_sar_Ch_v'
 import XHTML12_CHAPTER_4__MOTHERHOOD__FAMILIA from '@/components/xhtml/12_CHAPTER_4__Motherhood__Familia'
 import XHTML13_CHAPTER_5__PUBLIC_PERSONA_OF_DIF from '@/components/xhtml/13_CHAPTER_5__Public_Persona_of_Dif'
 import XHTML14_CHAPTER_6__DOLORES_HUERTA__ICONI from '@/components/xhtml/14_CHAPTER_6__Dolores_Huerta__Iconi'
 import XHTMLLOVE_2 from '@/components/xhtml/love_2'
 import XHTML15_EPILOGUE from '@/components/xhtml/15_EPILOGUE'
 import XHTML16_REFERENCES from '@/components/xhtml/16_REFERENCES'
 import XHTML17_INDEX from '@/components/xhtml/17_INDEX'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/xhtml/05_Contents",
 			"name" : "xhtml/05_Contents",
 			"component" : XHTML05_CONTENTS
 		},
 		{
 			"path" : "/xhtml/06_ACKNOWLEDGMENTS",
 			"name" : "xhtml/06_ACKNOWLEDGMENTS",
 			"component" : XHTML06_ACKNOWLEDGMENTS
 		},
 		{
 			"path" : "/xhtml/07_ABBREVIATIONS",
 			"name" : "xhtml/07_ABBREVIATIONS",
 			"component" : XHTML07_ABBREVIATIONS
 		},
 		{
 			"path" : "/xhtml/08_INTRODUCTION",
 			"name" : "xhtml/08_INTRODUCTION",
 			"component" : XHTML08_INTRODUCTION
 		},
 		{
 			"path" : "/xhtml/09_CHAPTER_1__Farm_Worker_Organizin",
 			"name" : "xhtml/09_CHAPTER_1__Farm_Worker_Organizin",
 			"component" : XHTML09_CHAPTER_1__FARM_WORKER_ORGANIZIN
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js